import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { SiteListClient } from './site-list-client.js';

export function useSiteListClient(): SiteListClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(() => new SiteListClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
